module.exports = __webpack_public_path__ + "img/b860a1ebba618f0cb48956422c11cba7.png";